import OverflowAutoStyles from './types';

const overflowAuto: OverflowAutoStyles = {
    overflow: 'auto',
};

export default overflowAuto;
